import { gcm } from '@noble/ciphers/aes.js';
import { sha256 } from '@noble/hashes/sha2.js';
import { utf8ToBytes } from '@noble/hashes/utils.js';

const encoder = new TextEncoder();

function keyFromEditionId(editionId: string): Uint8Array {
  return sha256(utf8ToBytes(editionId));
}

async function encryptRole(roles: string[], editionId: string): Promise<string> {
  const key = keyFromEditionId(editionId);
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const ciphertext = gcm(key, iv).encrypt(encoder.encode(JSON.stringify(roles)));
  const combined = new Uint8Array(iv.length + ciphertext.length);
  combined.set(iv);
  combined.set(ciphertext, iv.length);
  return btoa(Array.from(combined, (b) => String.fromCharCode(b)).join(""))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=/g, "");
}

export const getRoleDeeplink = async (role: string, editionId: string) => {

  console.log('editionId', editionId)
  return `${process.env.REACT_APP_BUNDLE_ID}://role/${await encryptRole([role], editionId)}`;
};
